class tabsFullWidthImage {
    constructor() {
        if(window.innerWidth < 960) return;
        this.cname = "[data-comp='tabs-full-width-image']";
        this.components = document.querySelectorAll(this.cname);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach(component => {
            this.createFilters(component);
            this.events(component);
            this.activeFirstElement(component);
        });
    }

    createFilters(component) {
        let filtersItems = component.querySelectorAll("[data-category-text]");
        let filterContainer = component.querySelector("[data-comp='filters']");

        let filtersHTML = Array.from(filtersItems).map(item => `
            <li class="has-label-font-size has-text-color has-cream-background-color" data-value="${item.dataset.categoryText}">${item.textContent}</li>
        `).join("");

        filterContainer.innerHTML = filtersHTML;
        filterContainer.classList.add("show");
    }
    events(component) {
        let filterContainer = component.querySelector("[data-comp='filters']");
        filterContainer.addEventListener('click', e => {
            let target = e.target;
            if (target.dataset.value) {
                this.filter(component, target);
            }
        });
    }

    filter(component, target) {
        let tabs = component.querySelectorAll("[data-content]");
        let filterContainer = component.querySelectorAll("[data-comp='filters'] li");

        if (tabs.length) {
            // Reset
            filterContainer.forEach(filter => filter.classList.remove("active"));
            tabs.forEach(tab => tab.classList.remove("active"));

            // Active
            target.classList.add("active");
            tabs.forEach(tab => {
                if (tab.dataset.content === target.dataset.value) {
                    tab.classList.add("active");
                }
            });
        }
    }
    activeFirstElement(component) {
        component.querySelector("[data-comp='filters'] li").classList.add("active");
        component.querySelector("[data-content]:first-child").classList.add("active");
    }

}

new tabsFullWidthImage();
